import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { ImagePluginInterface } from './definitions';
import { CAPACITOR_IMAGE_PLUGIN } from '../pluginConstants';

const ImagePresenterRaw = registerPlugin<ImagePluginInterface>(CAPACITOR_IMAGE_PLUGIN);
const ImagePlugin = withBridgedStackTrace(ImagePresenterRaw, CAPACITOR_IMAGE_PLUGIN);

export * from './definitions';
export { ImagePlugin };
